// extracted by mini-css-extract-plugin
export default {"nav":"Navigation_nav__kbJs4","active":"Navigation_active__IwBuj"};